import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';
import Popover from '@/components/popover_component.vue';
import LoaderPopover from '@/components/loaderpopover_component.vue';

export default {
    name: 'appointment',
    components: {
        Multiselect,
        DatePicker,
        Popover,
        LoaderPopover
    },
    data(){
        return {
            book_status: [],
            status : [
                {'status_id' : this.Constants.STATUS_BOOKED , 'status_name' : 'Booked', 'img' :'booked_icon.svg','color_class' : 'light_blue' },
                {'status_id' : this.Constants.STATUS_ARRIVED , 'status_name' : 'Arrived', 'img' :'arrived_icon.svg', 'color_class' : 'blue' },
                {'status_id' : this.Constants.STATUS_COMPLETED , 'status_name' : 'Completed', 'img' :'completed_icon.svg', 'color_class' : 'green' },
                {'status_id' : this.Constants.STATUS_EARLY_CANCELLED , 'status_name' : 'Cancelled', 'img' :'cancel_icon.svg','color_class' : 'text-danger' },
                {'status_id' : this.Constants.STATUS_LATE_CANCELLED , 'status_name' : 'Late Cancelled', 'img' :'late_cancel_icon.svg','color_class' : 'text-danger' },
                {'status_id' : this.Constants.STATUS_NO_SHOW , 'status_name' : 'No-show', 'img' :'noshow_icon.svg', 'color_class' : 'orange' },
            ],
            salons : [],
            staffs : [],
            services : [],
            filter_data : {},
            salon_selected : null,
            staff_selected : null,
            dates_selected : [moment(new Date(), "DD-MM-YYYY").format('MMM D, YYYY'), moment(new Date(), "DD-MM-YYYY").add(2, "days").format('MMM D, YYYY')],
            service_selected : null,
            bookings : {},
            book_date_index:'',
            book_index:'',
            status_selected : null,
            windowHeight : window.innerHeight - 250,
            selected_type:"Services"
        }
    },
    mounted() {
        this.$store.state.menu_toggle = false;
        this.getStore();
    },
    created() {
        window.addEventListener("resize", this.onResize);
    },
    destroyed(){
        window.removeEventListener("resize", this.onResize);
    },
    methods:{
        onResize(){
            this.windowHeight = window.innerHeight - 250;
        },
        async getStore(){
            await this.$store.dispatch('getStoreByOwnerId',[this.$store.state.api,this.$store.state.user_id]);

            if(Object.keys(this.$store.state.stores_data).length > 0){
                this.salons = this.$store.state.stores_data; 
            }

            this.salon_selected = this.$store.state.stores_data[0].store_id
            this.getStaff();
            this.getServices();
            this.getBookings();
        },

        async getStaff() {
            await this.$store.dispatch('getStaffByStoreId',[this.$store.state.api,this.salon_selected]);
           
            if(Object.keys(this.$store.state.store_staff_ids).length > 0){
                this.staffs = this.$store.state.store_staff_ids;
            }else{
                this.staffs = [];
            }
        },

        async getServices() {
            await this.$store.dispatch('getServiceByStoreId',[this.$store.state.api,this.salon_selected]);

            if(Object.keys(this.$store.state.store_service_ids).length > 0){
                this.services = this.$store.state.store_service_ids;
            }else{
                this.services = [];
            }
        },

        async getBookings() {
            this.$store.state.loader_popup = true
            this.getStaff();
            this.getServices();
            this.bookings = []
            this.book_status = []
            this.filter_data.store_id = this.salon_selected;
            if(this.dates_selected){
                this.filter_data.start_date = moment(this.dates_selected[0], 'MMM D, YYYY').format("YYYY-MM-DD");
                this.filter_data.end_date = moment(this.dates_selected[1], 'MMM D, YYYY').format("YYYY-MM-DD");
            }
            this.filter_data.staff_id = this.staff_selected;
            this.filter_data.serv_id = this.service_selected;
            this.filter_data.book_status = this.status_selected;
            this.filter_data.book_type = this.selected_type;

            await this.$store.dispatch('staffwise_bookings',[this.$store.state.api,this.filter_data]);

            if(Object.keys(this.$store.state.staff_wise_bookings.staffwise_bookings).length > 0){
                let all_bookings = this.$store.state.staff_wise_bookings.staffwise_bookings;
                let z= 0;
                for (let i = 0; i < all_bookings.length; i++) {
                    let day_book_array = []
                    day_book_array.date = all_bookings[i].date
                    day_book_array.bookings = []
                    
                    for (let j = 0; j < all_bookings[i].staff.length; j++){
                        
                        for (let k = 0; k < all_bookings[i].staff[j].bookings.length; k++){
  
                            if(all_bookings[i].staff[j].bookings[k].service_name != 'Break'){
                                if(!all_bookings[i].staff[j].bookings[k].transaction_details){
                                    all_bookings[i].staff[j].bookings[k].transaction_details = [{total_book_trans_paid_now:0,last_book_trans_created_date:""}];
                                }
                                for(let l=0 ; l < this.status.length ; l++){
                                    
                                    if(all_bookings[i].staff[j].bookings[k].book_status == this.status[l].status_id){
                                        this.book_status.push(this.status[l])
                                    }
                                }

                                all_bookings[i].staff[j].bookings[k].status_index = z
                                z = z+1;
                                
                                day_book_array.bookings.push(all_bookings[i].staff[j].bookings[k])
                            }
                        }
                    }
                    if(day_book_array.bookings.length > 0){
                        this.bookings.push(day_book_array);
                    }
                }
            }
            this.$store.state.loader_popup = false

        },

        book_select_index(index,status){
            this.$session.set('appoint_book_index',index)
            this.$session.set('before_change_status',status)
        },

        status_change(book_id, multi_bookid, selected, index, index1){

            this.$session.set('book_id',book_id)
            this.$session.set('multi_book_id',multi_bookid)

            if(selected == this.Constants.STATUS_BOOKED){
                this.$store.state.booked_popup = true;
            }
            else if(selected == this.Constants.STATUS_ARRIVED){
                this.$store.state.arrived_popup = true;
            }
            else if(selected == this.Constants.STATUS_COMPLETED){
                this.$store.state.completed_popup = true;
            }
            else if(selected == this.Constants.STATUS_NO_SHOW){
                this.$store.state.noshow_popup = true;
            }
            else if(selected == this.Constants.STATUS_EARLY_CANCELLED){
                this.$store.state.cancel_popup = true;
            }
            else if(selected == this.Constants.STATUS_LATE_CANCELLED){
                this.$store.state.latecancel_popup = true;
            }
            this.book_date_index = index;
            this.book_index = index1;            
        },

        cancelStatusChange(type){
            this.book_status[this.$session.get('appoint_book_index')] =  this.$session.get('before_change_status')
            this.changeValue(type,1);
        },

        changeValue(type,cancel){
            if(!cancel)
                this.bookings[this.book_date_index].bookings[this.book_index].book_status=type;
            if(type == this.Constants.STATUS_BOOKED){
                this.$store.state.booked_popup = false;
            }
            else if(type == this.Constants.STATUS_ARRIVED){
                this.$store.state.arrived_popup = false;
            }
            else if(type == this.Constants.STATUS_COMPLETED){
                this.$store.state.completed_popup = false;
            }
            else if(type == this.Constants.STATUS_NO_SHOW){
                this.$store.state.noshow_popup = false;
            }
            else if(type == this.Constants.STATUS_EARLY_CANCELLED){
                this.$store.state.cancel_popup = false;
            }
            else if(type == this.Constants.STATUS_LATE_CANCELLED){
                this.$store.state.latecancel_popup = false;
            }

        },

        open_booking(book_id, multi_bookid){
            this.$session.set('book_id',book_id)
            this.$session.set('multi_book_id',multi_bookid)
            this.$router.push('/viewbooking')
        }

    },
    filters:{
        date_format(date){
            return moment(date , 'YYYY-MM-DD').format("ddd MMM DD, YYYY");
        },

        time_format(time){
            return moment(time , 'YYYY-MM-DD HH:mm:ss').format("hh:mm A");
        },
    }
}